import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navigation } from "lucide-react";
import api from "../../lib/api";

export default function NearbyAirports({ lat, lon, cityName }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (lat == null || lon == null) { setItems([]); return; }
    setItems(null);
    api.get("/travel/nearby", { params: { lat, lon, limit: 6 } })
      .then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [lat, lon]);

  return (
    <div className="border border-zinc-300 bg-white p-5" data-testid="nearby-airports">
      <h3 className="font-heading font-900 text-blue-600 text-lg flex items-center gap-2 mb-4"><Navigation className="w-5 h-5" /> Nearby Airports</h3>
      {lat == null ? <p className="text-sm text-muted-foreground">Set your home city to see nearby airports.</p>
        : items == null ? <p className="text-sm text-muted-foreground">Finding airports near {cityName}…</p>
          : items.length === 0 ? <p className="text-sm text-muted-foreground">No major airports found nearby.</p>
            : (
              <div className="space-y-2">
                {items.map((a) => (
                  <Link key={a.id} to={`/airports/${a.iata_code || a.id}`} data-testid={`nearby-${a.id}`}
                    className="flex items-center justify-between group">
                    <span className="text-sm truncate group-hover:text-primary transition-colors">
                      <span className="font-mono text-primary">{a.iata_code}</span> — {a.name}
                    </span>
                    <span className="font-mono text-xs text-muted-foreground shrink-0">{a.distance_km} km</span>
                  </Link>
                ))}
              </div>
            )}
    </div>
  );
}
